export default defineNuxtPlugin((_nuxtApp) => {
	const store = useFirebaseStore();
	store.initializeAnalytics();
});
